import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../app/firebase";

export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }
      const token = await user.getIdTokenResult(true); // force refresh
      setIsAdmin(!!token.claims.admin);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return { isAdmin, loading };
};
